import NiceModal from "@ebay/nice-modal-react";
import { medusaRequester, requester, storeRequester } from "App";
import clsx from "classnames";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addCommas } from "shared/utils/Utils";
import { AuthContext } from "providers/AuthProvider";
import style from "./NormalProductCard.module.scss"
import medusaClient from "shared/MedusaClient";
// import { getCustomer } from "shared/medusa/action";
import Dummy from "components/Dummy";
import cartIcon from "resources/img/category/cart.png";
import heartIcon from "resources/img/category/heart-regular.svg";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { renderPrice } from "shared/utils/Utils";
import HorizontalCard from "./HorizontalCard";
import EventSticker from "./sticker/EventSticker";
import { toast } from "react-toastify";




function AddWishCard(props) {
  const { data, type, skeleton, restock, interests, onWishToggle } = props;
  const { userName } = useContext(AuthContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useContext(BrowserDetectContext);
  const [isData, setData] = useState();



  // 현재 상품이 관심 상품인지 확인
  const isWished = interests?.some(interest => interest.product_id === data.id) || false;

  const onProductClick = () => {

    if (restock) {
      navigate(`/product/detail/${data.product_id}`);
    } else {
      navigate(`/product/detail/${data.id}`);
    }

  };
  const addCartButtonClick = (e) => {
    e.stopPropagation();
    if (isMobile) {
      NiceModal.show("mobileAddCart", { product: data });
    } else {

      NiceModal.show("addCartCount", { product: data });
    }
  };
  const addWishButtonClick = (e) => {
    e.stopPropagation();
    if (!userName) return
    const req = { product_id: data.id }
    storeRequester.postInterest(req, (result => {
      toast.success(`상품이 관심목록에 추가되었습니다`);

    }))

  };

  const handleWishClick = (e) => {
    e.stopPropagation();
    if (!userName) return;
    onWishToggle(data.id, isWished);
  };

  const displayPrice = renderPrice(data, userName);


  useEffect(() => {
    if (data) {
      setData(data);
    }
  }, [data]);


  const HeartIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={clsx(style.heartIcon, { [style.wished]: isWished })}
    >
      {isWished ? (
        // Filled heart path
        <path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z" />
      ) : (
        // Outline heart path
        <path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z" />
      )}
    </svg>
  );

  return (
    <div
      className={clsx(style.wrap, {
        [style.horizontal]: type === "horizontal",
      })}
      style={{ padding: isMobile ? null : null, maxWidth: isMobile && type !== "horizontal" && "" }}
    >
      {type === "horizontal" ? (
        <HorizontalCard
          skeleton={skeleton}
          data={data}
          onProductClick={onProductClick}
          addCartButtonClick={(e) => {  // e.stopPropagation() 추가
            e.stopPropagation();
            addCartButtonClick(e);
          }}
          rank={props.rank}
          interests={interests}
          onWishToggle={onWishToggle}
        />
      ) : (
        <VerticalFlex>
          <FlexChild borderBottomRightRadius={"0"}>
            {skeleton ? (
              <div
                className={style.thumbnail}
                style={{ backgroundColor: "#ebebeb" }}
              >
                <SquareWrapper>
                  {skeleton ? (
                    <SkeletonImage width={100} />
                  ) : (
                    <img
                      className={style.image}
                      src={data.thumbnail}
                      alt={""}
                    />
                  )}
                </SquareWrapper>
              </div>
            ) : (
              <div
                className={style.thumbnail}
                style={{ backgroundColor: `${data.bgColor}11` }}
              >
                <SquareWrapper>
                  {props.rank && (
                    <div className={style.indexCircle}>{props.rank}</div>
                  )}
                  <img
                    onClick={onProductClick}
                    className={isMobile ? style.mobileImage : style.image}
                    src={data.thumbnail}
                    alt={""}
                  />
                </SquareWrapper>
              </div>
            )}
          </FlexChild>
          <FlexChild height={"fit-content"} backgroundColor={"white"}>
            <div className={style.buttonWrap}>
              <img
                src={cartIcon}
                onClick={skeleton ? null : addCartButtonClick}
                className={clsx(style.button, style.wishCartButton)}
              />
            </div>
            <div style={{ backgroundColor: "white", borderRadius: '50%', zIndex: '99', position: 'relative' }}>
              <div
                onClick={skeleton ? null : handleWishClick}
                className={clsx(style.button, style.wishButton)}
              >
                <HeartIcon />
              </div>
            </div>
            <PaddingWrapper padding={"15px 0 0 0"}>
              {skeleton ? (
                <Center width={"100%"} textAlign={"left"}>
                  <SkeletonText width={50} size={16} />
                  <SkeletonText width={50} size={16} />
                  <SkeletonText width={50} size={16} />
                  <Inline>
                    <SkeletonText width={50} size={10} />
                    <SkeletonText width={50} size={10} />
                    <SkeletonText width={50} size={10} />
                  </Inline>
                  <SkeletonText width={50} size={10} />
                  <SkeletonText width={50} size={10} />
                </Center>
              ) : (
                <Center width={"100%"} maxWidth={200} textAlign={"left"}>
                  <P
                    width={isMobile ? "150px" : "100%"}
                    textHover
                    cursor
                    onClick={onProductClick}
                    ellipsis
                    size={isMobile ? 16 : 20}
                    weight={700}
                    whiteSpace={"nowrap"}
                    overFlow={"hidden"}
                    textOverflow={"ellipsis"}
                  >
                    {data.title}
                  </P>
                  <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                    <FlexChild justifyContent={"flex-start"}>
                      <P
                        width={isMobile ? "150px" : "100%"}
                        textHover
                        cursor
                        onClick={onProductClick}
                        textAlign={"left"}
                        size={isMobile ? 16 : 20}
                        weight={"bold"}
                        color={"rgba(89, 87, 87, 1)"}
                        textDecoration={data.currentPrice && "line-through"}
                      >
                        {Array.isArray(displayPrice) ? (
                          displayPrice.map((line, index) => (
                            <div key={index}>{line}</div>
                          ))
                        ) : (
                          displayPrice
                        )}
                      </P>
                    </FlexChild>
                  </HorizontalFlex>
                  <Dummy height={"5px"} />
                  {(data && data.event) || data.discount_price ? (
                    <EventSticker
                      isEvent={data.event}
                      discount={data.discount_price}
                      price={data.price}
                    />
                  ) : (
                    <P
                      height={"20px"}
                      ellipsis
                      size={12}
                      weight={"900"}
                      color={"red"}
                    ></P>
                  )}
                </Center>
              )}
            </PaddingWrapper>
          </FlexChild>
        </VerticalFlex>
      )}
    </div>
  );
}

export default AddWishCard;
